<template>
  <AdminCandidate>
    <transition
      name="fade"
      mode="out-in"
      appear
    >
      <div
        v-if="stepInitial"
        class="row p-0 m-0"
      >
        <div class="col-lg-1"></div>
        <div
          class="col-lg-10 col-xs-12"
          :class="{ no_radius: mobile ? true : false }"
        >
          <div class="row mr-0 ml-0 mt-5 mb-5">
            <div class="col-lg-1"></div>

          </div>
        </div>
        <div class="col-lg-1"></div>
        <div class="col-lg-1"></div>

        <div
          class="col-lg-10 col-xs-12"
          style="
            margin-top: -100px;
            background-color: #9381ff;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
          "
          :style="{
            'border-radius': mobile ? '0px' : '15px',
          }"
        >
          <div class="row mr-0 ml-0 mb-3">
            <div class="col-lg-1"></div>
            <div class="col-lg-10 center">
              <div v-if="this.videos.length == 1">
                <h2
                  class="label-bold color-white mt-4 mb-3"
                  style="font-size: em; text-align: center"
                >
                  Assista o vídeo que preparamos para você antes de continuar!
                </h2>
                <hr class="bg-white mb-3" />
              </div>
              <div v-if="this.videos.length > 1">
                <h2
                  class="label-bold color-white mt-4 mb-3"
                  style="font-size: em; text-align: center"
                >
                  Assista os vídeos que preparamos para você antes de continuar!
                </h2>
                <hr class="bg-white mb-3" />
              </div>
              <div>
                <h1
                  class="center mt-3 mb-3"
                  style="color: #44246b"
                >
                  <b>{{ job.title }}</b>
                </h1>
              </div>
              <div
                class="row mb-3"
                v-if="videos.length > 0"
              >
                <div
                  :class="{ hide: mobile }"
                  class="col-lg-1 d-flex align-items-center justify-content-start mb-1"
                >
                  <span
                    class="d-flex align-items-center justify-content-center pointer"
                    @click="decrementOne"
                    v-if="this.countVideo >= 1"
                  >
                    <i
                      class="p-1 fas color-white fa-angle-left f50 btn-arrow-video"
                      style="background-color: #01b9f7"
                    ></i>
                  </span>
                </div>
                <div
                  class="col-lg-10"
                  style="max-width= 100%"
                >
                  <div v-if="videos.length > 0">
                    <span class="label-bold color-white">
                      {{ videos[this.countVideo].name }}
                    </span>
                    <div
                      class="center"
                      v-if="videos[this.countVideo].iframe == ''"
                    >
                      <video
                        style="max-width: 100%"
                        v-show="videos[this.countVideo].video"
                        controls
                        controlslist="nodonwload"
                        playsinlineatributo
                        preload="yes"
                        id="buttonVideo"
                      >
                        <source
                          :src="videos[this.countVideo].video"
                          type="video/mp4"
                        />
                      </video>
                    </div>
                    <div
                      class="center"
                      v-if="videos[this.countVideo].iframe != ''"
                    >
                      <video-embed
                        class="full"
                        :src="videos[this.countVideo].iframe"
                      ></video-embed>
                    </div>
                  </div>
                  <div
                    class="center"
                    :class="{ hide: mobile }"
                  >
                    <span class="f12 color-white">{{ this.countVideo + 1 }} de
                      {{ this.videos.length }}</span>
                  </div>
                </div>
                <div
                  :class="{ hide: mobile }"
                  class="col-lg-1 d-flex align-items-center justify-content-end"
                >
                  <span
                    class="d-flex align-items-center justify-content-center pointer"
                    @click="increaseOne"
                    v-if="countVideo != videos.length - 1"
                  >
                    <i
                      class="p-1 fas color-white fa-angle-right f50 btn-arrow-video"
                      style="background-color: #01b9f7"
                    ></i>
                  </span>
                </div>
              </div>
              <div
                class="row mb-3 center"
                v-if="mobile == true"
              >
                <div class="width48">
                  <span
                    class="d-flex align-items-center justify-content-center pointer"
                    @click="decrementOne"
                    v-if="this.countVideo >= 1"
                  >
                    <i
                      class="p-1 fas color-white fa-angle-left f50 btn-arrow-video"
                      style="background-color: #01b9f7"
                    ></i>
                  </span>
                </div>
                <div class="width48">
                  <span
                    class="d-flex align-items-center justify-content-center pointer"
                    @click="increaseOne"
                    v-if="countVideo != videos.length - 1"
                  >
                    <i
                      class="p-1 fas color-white fa-angle-right f50 btn-arrow-video"
                      style="background-color: #01b9f7"
                    ></i>
                  </span>
                </div>
                <div class="center width100">
                  <span class="f12 color-gray">{{ this.countVideo + 1 }} de {{ this.videos.length }}</span>
                </div>
              </div>

              <div
                v-if="!is_credit_suisse"
                class="row mb-3 mt-3"
              >
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                  <div>
                    <h1
                      class="center mt-3 mb-3"
                      style="color: #44246b"
                    >
                      <b>Descrição:</b>
                    </h1>
                  </div>
                  <div>
                    <span
                      style="text-align: left"
                      class="f18 color-white"
                      v-html="this.job.description"
                    >
                      {{ this.job.description }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row text-left">
                <div class="col-lg-1"></div>
                <div class="col-lg-10 col-xs-12">
                  <div class="row">
                    <div
                      class="col-lg-12 col-xs-12 text-truncate"
                      v-if="job.skills != ''"
                    >
                      <h4
                        class="mt-5 mb-3"
                        style="color: #44246b"
                      >
                        <b>Competências Técnicas:</b>
                      </h4>
                      <span
                        v-for="item in this.job.skills"
                        :key="item.id"
                        class="f18 color-white p-0 m-0"
                      >
                        {{ capitalizeFirstLetter(item) }}<br />
                      </span>
                    </div>
                    <div
                      class="col-lg-12 col-xs-12 text-truncate"
                      v-if="job.behavioral != ''"
                    >
                      <h4
                        class="mt-5 mb-3"
                        style="color: #44246b"
                      >
                        <b>Competências Comportamentais:</b>
                      </h4>
                      <span
                        v-for="item in this.job.behavioral"
                        :key="item.id"
                        class="f18 color-white p-0 m-0"
                      >
                        {{ capitalizeFirstLetter(item) }}<br />
                      </span>
                    </div>
                    <div
                      v-if="!is_credit_suisse"
                      class="col-lg-12 col-xs-12"
                    >
                      <div
                        v-if="
                          !job.hide_remuneration &&
                          job.minimum_remuneration != 0
                        "
                        style="text-align: start"
                        class="mt-3 label-bold"
                      >
                        <h4
                          class="mt-5 mb-3"
                          style="color: #44246b"
                        >
                          <b>Salário:</b>
                        </h4>

                        <span class="f18 color-white p-0 m-0">
                          R$
                          {{ formatCurrency(this.job.minimum_remuneration) }}
                          {{
                            this.job.maximum_remuneration != 0
                              ? " até R$ " +
                                formatCurrency(this.job.maximum_remuneration)
                              : ""
                          }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="col-lg-12 col-xs-12 hide text-truncate"
                      v-if="job.benefits != ''"
                    >
                      <h4
                        class="mt-5 mb-3"
                        style="color: #44246b"
                      >
                        <b>Benefícios:</b>
                      </h4>
                      <div style="margin-top: 20px">
                        <span
                          v-for="item in this.job.benefits"
                          :key="item"
                          class="f18 color-white p-0 m-0"
                        >
                          {{ capitalizeFirstLetter(item) }}<br />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-1"></div>
        <div class="col-lg-1"></div>
        <div
          class="col-lg-10 col-xs-12 bg-white"
          style="margin-top: -10px; border-radius: 15px"
        >
          <div class="row mt-5">
            <div
              class="col-12"
            >
              <div
                class="extra-description"
              >
                <span
                  v-html="this.job.extra_description"
                >

                </span>
              </div>
            </div>
          </div>
          <div class="center mt-5">
            <h2 class="color-primary label-bold">
              Está pronto? Vamos começar?
            </h2>

            <h5 class="color-primary mt-4">
              Faça seu login ou cadastro e boa sorte!
            </h5>
            <h5 class="color-primary mt-4">
              Esperamos te ver em breve na próxima etapa.
            </h5>
          </div>
          <div
            v-if="!isJobConcluded"
          >
            <div class="row">
              <div 
                class="col-lg-6 p-5 col-xs-12"
              >
                <h4 class="color-primary mt-3 header_border">
                  Crie sua <b>conta</b>
                </h4>
                <div class="row mt-4">
                  <div class="col-lg-5 col-xs-12 bg-white mt-4">
                    <button
                      style="
                        background-color: #0076b5 !important;
                        border: 0px;
                        height: 40px;
                      "
                      class="btn btn-lg width100 btn-primary"
                      @click="loginLinkedin(false)"
                    >
                      <i class="fab fa-linkedin"></i> Linkedin
                    </button>
                  </div>
                  <div class="col-lg-1 center py-1 mt-4 center">ou</div>
                  <div class="col-lg-6 bg-white pt-4">
                    <input
                      class="form-control width100 bg-input-candidate"
                      style="
                        float: right;
                        height: 40px;
                        text-align: center;
                        border: none;
                      "
                      :class="{
                        'is-invalid': $v.user.name.$error,
                        'is-valid': !$v.user.name.$invalid,
                      }"
                      type="text"
                      v-model="user.name"
                      placeholder="Nome completo*"
                    />
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-lg-12 col-xs-12 pt-3"
                    v-if="job.candidates_uniques"
                  >
                    <input
                      class="form-control width100 bg-input-candidate"
                      style="text-align: center; border: none; height: 40px"
                      type="text"
                      v-model="user.cpf"
                      v-mask="'###.###.###-##'"
                      :field="$v.user.cpf"
                      placeholder="CPF*"
                    />
                  </div>
                  <div class="col-lg-12 col-xs-12 pt-3">
                    <input
                      class="form-control width100 bg-input-candidate"
                      style="text-align: center; border: none; height: 40px"
                      :class="{
                        'is-invalid': $v.user.email.$error,
                        'is-valid': !$v.user.email.$invalid,
                      }"
                      type="text"
                      v-model="user.email"
                      placeholder="Email*"
                    />
                  </div>
                  <div class="col-lg-12 col-xs-12 pt-3">
                    <input
                      class="form-control width100 bg-input-candidate"
                      style="text-align: center; border: none; height: 40px"
                      :class="{
                        'is-invalid': $v.user.password.$error,
                        'is-valid': !$v.user.password.$invalid,
                      }"
                      type="password"
                      v-model="user.password"
                      placeholder="Senha*"
                    />
                  </div>
                  <div class="col-lg-12 col-xs-12 pt-3">
                    <input
                      class="form-control width100 bg-input-candidate"
                      style="text-align: center; border: none; height: 40px"
                      :class="{
                        'is-invalid': $v.confirm_password.$error,
                        'is-valid': !$v.confirm_password.$invalid,
                      }"
                      type="password"
                      v-model="confirm_password"
                      placeholder="Confirme a senha*"
                    />
                  </div>
                </div>
                <div class="row pb-4 pt-4">
                  <div
                    v-if="disclaimers.length == 0"
                  >
                    <div
                      v-if="!is_credit_suisse && !extra_checkboxes.length > 0"
                      class="col-lg-12 col-xs-12"
                    >
                      <label :class="{
                          seterror: !conditions && error_linkedin,
                        }">
                        <input
                          @change="changeConditions"
                          class="mt-2"
                          type="checkbox"
                        />
                        <span>Ao se candidatar a está vaga você Aceita e Concorda com
                          nossos</span>
                        <a
                          href="/termos_de_uso"
                          style="color: blue"
                        >Termos de Uso</a>
                        <span>e</span>
                        <a
                          href="/politicas_de_privacidade"
                          style="color: blue"
                        >Política de Privacidade</a>
                      </label>
                    </div>

                    <div
                      v-if="is_credit_suisse"
                      class="col-lg-12 col-xs-12"
                    >
                      <label :class="{
                        seterror: !conditions && error_linkedin,
                      }">
                        <input
                          @change="changeConditions"
                          class="mt-2"
                          type="checkbox"
                        />
                        <span>Declaro que li e concordo com a </span>
                        <a
                          href="/politicas_de_privacidade"
                          style="color: blue"
                        >Política de Privacidade</a>
                        <span>e</span>
                        <a
                          href="/termos_de_uso"
                          style="color: blue"
                        >Termos de Uso</a>.
                      </label>
                      <label :class="{
                        seterror: !conditions_credit_suisse && error_linkedin,
                      }">
                        <input
                          @change="changeCreditSuisseConditions"
                          class="mt-2"
                          type="checkbox"
                        />
                        <span>
                          Estou ciente de que não sou obrigado a preencher os campos que contenham os meus Dados Pessoais Sensíveis.
                          <br>
                          Li a Política de Privacidade e dou meu consentimento livre, informado e inequívoco de que os meus Dados Pessoais Sensíveis, caso sejam por mim preenchidos, poderão ser usados pela Mappit e Credit Suisse para oferta e preenchimento de vagas.
                        </span>
                      </label>
                    </div>
                    <div
                      v-if="extra_checkboxes"
                      class="col-12"
                    >
                      <div
                        v-for="(checkbox, checkbox_index) in extra_checkboxes"
                        :key="`checkbox-${checkbox_index}`"
                      >
                        <label :class="{
                            seterror: !extra_conditions || error_linkedin,
                          }">
                          <input
                            @change="changeExtraConditions(checkbox_index)"
                            class="mt-2"
                            type="checkbox"
                          />
                          <span v-html="checkbox"></span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12 col-xs-12">
                    <button
                      type="button"
                      :disabled="load"
                      @click="goToQuestion"
                      class="btn full width100 normal-degrade btn-degrade btn-login-candidate"
                    >
                      <div v-if="!load">
                        <i class="fa fa-check"></i>
                        Cadastrar
                      </div>

                      <div
                        v-show="load"
                        class="spinner-border text-light"
                        role="status"
                      >
                        <span class="sr-only"></span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
              <div 
                class="col-lg-6 p-5 col-xs-12"
              >
                <h4 class="color-primary mt-3 header_border">
                  Faça <b>login</b>
                </h4>
                <div class="row mt-4">
                  <div class="col-lg-5 col-xs-12 bg-white mt-4">
                    <button
                      style="
                        background-color: #0076b5 !important;
                        border: 0px;
                        height: 40px;
                      "
                      class="btn btn-lg width100 btn-primary"
                      @click="loginLinkedin(true)"
                    >
                      <i class="fab fa-linkedin"></i> Linkedin
                    </button>
                  </div>
                  <div class="col-lg-1 center py-1 mt-4 center">ou</div>
                  <div class="col-lg-6 bg-white pt-4">
                    <input
                      class="form-control width100 bg-input-candidate"
                      style="
                        float: right;
                        height: 40px;
                        text-align: center;
                        border: none;
                      "
                      :class="{
                        'is-invalid': $v.login.email.$error,
                        'is-valid': !$v.login.email.$invalid,
                      }"
                      type="text"
                      v-model="login.email"
                      placeholder="Email*"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-xs-12 pt-3">
                    <input
                      class="form-control width100 bg-input-candidate"
                      style="text-align: center; border: none; height: 40px"
                      :class="{
                        'is-invalid': $v.login.password.$error,
                        'is-valid': !$v.login.password.$invalid,
                      }"
                      type="password"
                      v-model="login.password"
                      placeholder="Senha*"
                    />
                  </div>
                </div>
                <div class="row pb-4 pt-3">
                  <div class="col-lg-12 col-xs-12">
                    <button
                      type="button"
                      :disabled="load_login"
                      @click="loginCandidate"
                      class="btn full width100 btn-degrade normal-degrade btn-login-candidate"
                    >
                      <div v-if="!load_login">Entrar</div>

                      <div
                        v-show="load_login"
                        class="spinner-border text-light"
                        role="status"
                      >
                        <span class="sr-only"></span>
                      </div>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-12">
                    <a :href="'/candidates/password/new?token=' + account_uid">
                      Esqueceu sua senha? clique aqui
                    </a>
                  </div>
                </div>
              </div>
              <!-- <div
                v-if="!accepts_login && job.uid == '3xw0ptkh'"
                class="col-lg-6 p-5 col-xs-12"
              >
                <h4 class="color-primary mt-3 header_border">
                  Faça <b>login</b>
                </h4>
                <div class="center mt-5 mb-5">
                  <h2 class="color-primary label-bold">
                    Esta vaga já foi encerrada!
                  </h2>
                </div>
              </div> -->
            </div>
          </div>
          <div
            v-if="isJobConcluded"
            class="col-lg-12 col-xs-12 bg-white"
            style="margin-top: -10px; border-radius: 15px"
          >
            <div class="center mt-5 mb-5">
              <h2 class="color-primary label-bold">
                Esta vaga já foi encerrada!
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row col-lg-12"
        style="height: 100px"
      ></div>
      <Mandatory
        v-if="stepMandatory"
        :job="job"
      />
      <FormQuestion v-if="stepForm" />
      <Questions
        :account_uid="account_uid"
        :job_questions="job_questions"
        v-if="stepVideo"
      />
      <div v-if="stepBigfive">
        <Bigfive
          :bigfive_uid="bigfive.uid"
          :candidate_uid="user.uid != '' ? user.uid : candidate_uid"
          :amount_itens="bigfive.amount_itens"
          :account_uid="account_uid"
        />
      </div>
      <Congratulation
        v-if="stepFinal"
        :show="!job.mandatory_cv"
      />
    </transition>
  </AdminCandidate>
</template>

<script>
import CurriculumUpload from "components/CurriculumUpload.vue";
import { required, email, minLength } from "vuelidate/lib/validators";
import AdminCandidate from "layouts/AdminCandidate.vue";
import Questions from "@/Jobs/Questions.vue";
import FormQuestion from "@/Jobs/FormQuestions.vue";
import Congratulation from "@/Jobs/Congratulation.vue";
import Bigfive from "@/Bigfives/Test.vue";
import { isMobile } from "mobile-device-detect";
import Mandatory from "@/Jobs/Mandatory.vue";
import DisclaimerDialog from "components/DisclaimerDialog.vue";

export default {
  components: {
    AdminCandidate,
    Questions,
    Congratulation,
    FormQuestion,
    CurriculumUpload,
    Bigfive,
    Mandatory,
    DisclaimerDialog
  },
  props: [
    "job",
    "job_questions",
    "job_link",
    "candidate_id",
    "candidate_uid",
    "applies",
    "index",
    "url",
    "videos",
    "account_uid",
    "bigfive",
    "recruiting_company",
    "extra_checkboxes",
    "disclaimers"
  ],
  data: () => ({
    mobile: isMobile,
    file: "",
    conditions: false,
    conditions_credit_suisse: false,
    extra_conditions: true,
    accepts_login: true,
    user: {
      name: "",
      email: "",
      password: "",
      cpf: "",
      personal_site: "",
      personal_portfolio: "",
      accept_terms: false,
      accept_politcs: false,
      accept_credit_suisse_terms: false,
    },
    login: {
      email: "",
      password: "",
    },
    confirm_password: "",
    error_linkedin: false,
    load_login: false,
    load: false,
    stepInitial: false,
    stepMandatory: false,
    stepForm: false,
    stepVideo: false,
    stepBigfive: false,
    stepFinal: false,
    countVideo: 0,
    hasVideoBack: false,
    skills: "",
    behaviorals: "",
    is_credit_suisse: false,
    extra_checkboxes_validation: [],
    disclaimers_validation: false,
  }),
  watch: {
    stepInitial(val) {
      if (val) {
        setTimeout(() => {
          if (document.querySelector("iframe")) {
            document.querySelector("iframe").width = "100%";
          }
        }, 500);
      }
    },
  },
  mounted() {
    if (this.account_uid == "cektp8b4") {
      this.is_credit_suisse = true;
    }
    this.extra_checkboxes_validation = this.extra_checkboxes.map(() => {
      return false;
    });
    if (!this.candidate_id) {
      setTimeout(() => {
        this.stepInitial = true;
      }, 500);
    } else {
      if (this.job.mandatory_cv || this.job.mandatory_profile) {
        this.stepMandatory = true;
      } else {
        if (this.job.ask_remuneration == true) {
          this.stepForm = true;
        } else {
          this.stepVideo = true;
        }
      }
    }

    this.skills = this.job.skills;
    this.behaviorals = this.job.behavioral;

    if (this.disclaimers.length > 0) {
      this.openDisclaimers()
    }

    eventBus.$on("videoScreen", (index) => {
      this.stepInitial = false;
      this.stepMandatory = false;
      this.stepForm = false;
      this.stepVideo = true;
      this.stepFinal = false;
    });

    eventBus.$on("formQuestionScreen", (index) => {
      this.stepInitial = false;
      this.stepMandatory = false;
      this.stepForm = true;
      this.stepVideo = false;
      this.stepFinal = false;
    });

    eventBus.$on("finalScreen", (index) => {
      this.stepInitial = false;
      this.stepForm = false;
      this.stepVideo = false;

      if (this.job.bigfive) {
        this.stepBigfive = true;
        this.stepFinal = false;
      } else {
        this.stepFinal = true;
      }
    });

    eventBus.$on("gotoFinal", (index) => {
      this.gotoFinal();
    });

    eventBus.$on("setDisclaimersValue", (status) => {
      this.disclaimers_validation = status;
      if (this.disclaimers_validation) {
        this.user.accept_terms = true;
        this.user.accept_politcs = true;
        this.$toast.success("Termos aceitos com sucesso!");
        this.$modal.hideAll();
      }
    });
  },
  computed: {
    isJobConcluded() {
      const date = new Date();
      let conclution_date = new Date(this.job.date_conclusion);
      if(date > conclution_date) {
        conclution_date.setDate(conclution_date.getDate() + 7);
        if (date > conclution_date) {
          this.accepts_login = false;
        }
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    changeConditions() {
      this.conditions = !this.conditions;
      this.user.accept_terms = this.conditions;
      this.user.accept_politcs = this.conditions;
    },
    changeCreditSuisseConditions() {
      this.conditions_credit_suisse = !this.conditions_credit_suisse;
      this.user.accept_credit_suisse_terms = this.conditions_credit_suisse;
    },
    changeExtraConditions(index) {
      if (this.extra_checkboxes_validation[index]) {
        this.extra_checkboxes_validation[index] = false;
      } else {
        this.extra_checkboxes_validation[index] = true;
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "BRL",
      })
        .format(value)
        .replace("R$", "")
        .trim();
    },
    isValidCpf(cpf) {
      if (typeof cpf !== "string") return false;
      cpf = cpf.replace(/[\s.-]*/gim, "");
      if (
        !cpf ||
        cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999"
      ) {
        return false;
      }
      var soma = 0;
      var resto;
      for (var i = 1; i <= 9; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
      resto = (soma * 10) % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(cpf.substring(9, 10))) return false;
      soma = 0;
      for (var i = 1; i <= 10; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(cpf.substring(10, 11))) return false;
      return true;
    },
    loginCandidate() {
      this.load_login = true;
      if (this.$v.login.$invalid) {
        this.$toast.error("PREENCHA OS DADOS CORRETAMENTE PARA LOGAR");
        this.load_login = false;
        return false;
      }
      axios
        .post("/candidates/sessions", {
          candidates: {
            email: this.login.email,
            password: this.login.password,
          },
          account_uid: this.account_uid,
        })
        .then((response) => {
          if (response.data.candidates_uniques) {
            this.$toast.error(
              "Essa vaga so aceita uma inscrição por pessoa, provavelmente você já se inscreveu em outra vaga."
            );
          }

          if (response.data.status) {
            this.createApply({ email: this.login.email }, this.load_login);
            this.load_login = false;
            return;
          }

          this.load_login = false;
          this.$toast.error(
            "ERRO AO LOGAR NA APLICAÇÃO, CONFIRA SEU EMAIL E SENHA"
          );
        })
        .catch((error) => {
          console.log(error);
          this.load_login = false;
          this.$toast.error("ERRO AO LOGAR NA APLICAÇÃO");
        });
    },
    loginLinkedin(login_type) {
      if (!login_type) {
        if (this.extra_checkboxes?.length > 0) {
          let valid = true;
          this.extra_checkboxes_validation.forEach((checkbox) => {
            if (!checkbox) {
              valid = false;
            }
          });
          if (!valid) {
            this.$toast.error(
              "ACEITE OS TERMOS DE USO E POLITICAS DE PRIVACIDADE PARA CONTINUAR."
            );
            this.error_linkedin = true;
            this.load = false;
            return false;
          }
          this.user.accept_terms = true;
          this.user.accept_politcs = true;
        }
        if (this.disclaimers.length > 0 && !this.disclaimers_validation) {
          this.$toast.error(
            "ANTES DE CONTINUAR CLICK EM ACEITAR OS TERMOS DE USO E POLITÍCAS DE PRIVACIDADE"
          );
          this.load = false;
          this.error_linkedin = true;
          return false;
        }
        if (!this.user.accept_terms) {
          this.error_linkedin = true;
          this.$toast.error(
            "ANTES DE CONTINUAR CLICK EM ACEITAR OS TERMOS DE USO E POLITÍCAS DE PRIVACIDADE"
          );
          return;
        }
      }
      this.error_linkedin = false;

      axios
        .post("/candidates/sessions/linkedin", {
          job_link: this.job_link,
          job_uid: this.job.uid,
          account_uid: this.account_uid,
        })
        .then((response) => {
          window.location = "/recruiters/auth/linkedin";
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("ERRO AO APLICAR A ESSA VAGA");
        });
    },
    increaseOne() {
      if (this.countVideo < this.videos.length - 1) {
        this.countVideo += 1;
        this.loadVideo();
      }
    },
    decrementOne() {
      if (this.countVideo > 0) {
        this.countVideo -= 1;
        this.loadVideo();
      }
    },
    loadVideo() {
      if (document.querySelector("#buttonVideo"))
        document.querySelector("#buttonVideo").load();
    },
    gotoFinal() {
      this.stepInitial = false;
      this.stepForm = false;
      this.stepVideo = false;
      this.stepBigfive = false;
      this.stepFinal = true;
    },
    goToQuestion() {
      if (!this.validForm()) {
        return;
      }

      if (this.job.candidates_uniques) {
        if (this.user.cpf) {
          this.user.cpf = this.user.cpf.replaceAll(".", "");
          this.user.cpf = this.user.cpf.replaceAll("-", "");
        }
        if (!this.isValidCpf(this.user.cpf)) {
          this.$toast.error("cpf inválido, preencha corretamente");
          return;
        }
      }

      this.load = true;
      this.createApply(this.user, this.load);
    },
    createApply(user, load) {
      axios
        .post("/candidates/apply", {
          candidates: user,
          jobs: {
            uid: this.job.uid,
            account_uid: this.account_uid ? this.account_uid : false,
          },
        })
        .then((response) => {
          if (response.data.status == false) {
            this.$toast.error(
              "ERRO: CANDIDATO JÁ EXISTE OU O FORMULÁRIO FOI PREENCHIDO DE FORMA ERRADA "
            );
            this.load = false;
            return;
          }
          if (response.data.tag_error) {
            this.$toast.error("Sessão expirada! Preencha o código de acesso novamente.");
            location.reload();
            return;
          }
          this.$inertia.visit(
            "/candidates/apply/new/" + this.account_uid + "/" + this.job.uid,
            {
              method: "get",
              data: {},
              replace: true,
              preserveState: false,
              preserveScroll: false,
            }
          );
          return;
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("ERRO AO APLICAR A ESSA VAGA");
        });
    },
    async sendCurriculum() {
      eventBus.$emit("curriculum_load", true);
      this.file = this.$refs.file.files[0];
      if (!this.file) {
        this.$toast.error("POR FAVOR, CARREGUE UM CV PARA CONTINUAR");
        return false;
      }
      let formData = new FormData();

      if (this.file.size > 1024 * 1024) {
        alert("Arquivo muito grande (> 1MB)");
        return;
      }
      formData.append("candidates[curriculum_pdf]", this.file);
      let response = await axios.put("/candidates/curriculum", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (!response.data.response) {
        alert(
          "FORMATO DE CURRÍCULO INVÁLÇIDO, TENTE NOVAMENTE COM O FORMATO PDF OU DOC"
        );
        return false;
      }

      return true;
    },
    validForm() {
      if (this.extra_checkboxes?.length > 0) {
        let valid = true;
        this.extra_checkboxes_validation.forEach((checkbox) => {
          if (!checkbox) {
            valid = false;
            this.extra_conditions = false;
          }
        });
        if (!valid) {
          this.$toast.error(
            "ACEITE OS TERMOS DE USO E POLITICAS DE PRIVACIDADE PARA CONTINUAR."
          );
          this.load = false;
          return false;
        }
        this.user.accept_terms = true;
        this.user.accept_politcs = true;
        this.extra_conditions = true;
      }
      if (this.disclaimers.length > 0) {
        if (!this.disclaimers_validation) {
          this.$toast.error("Aceite os termos para continuar");
          setTimeout(() => {
            this.openDisclaimers();
          }, 100);
          return false;
        } else {
          this.user.accept_terms = true;
          this.user.accept_politcs = true;
        }
      }
      if (!this.user.accept_terms) {
        this.$toast.error(
          "ACEITE OS TERMOS DE USO E POLITICAS DE PRIVACIDADE PARA CONTINUAR."
        );
        this.load = false;
        return false;
      }
      if (this.is_credit_suisse && !this.user.accept_credit_suisse_terms) {
        this.$toast.error(
          "ACEITE OS TERMOS DE USO DE DADOS PESSOAIS SENSÍVEIS"
        );
        this.load = false;
        return false;
      }

      if (this.user.name == "") {
        this.$toast.error("PREECHA SEU NOME COMPLETO");
        this.load = false;
        return false;
      }

      if (this.$v.user.$invalid) {
        this.$toast.error("PREECHA OS DADOS CORRETAMENTE");
        this.load = false;
        return false;
      }

      if (this.user.password.length <= 6) {
        this.$toast.error("SENHA DEVE SER MAIOR QUE 6 CARACTERES");
        this.load = false;
        return false;
      }

      const name = this.user.name.split(" ");

      if (name.length < 2) {
        this.$toast.error("PREENCHA SEU NOME COMPLETO");
        this.load = false;
        return false;
      }

      if (this.user.password != this.confirm_password) {
        this.$toast.error("SENHA E CONFIRMAÇÃO DE SENHA ESTÃO DIFERENTES");
        this.load = false;
        return false;
      }

      return true;
    },
    openDisclaimers() {
      this.$modal.show(
        DisclaimerDialog,
        {
          disclaimers: this.disclaimers
        },
        {
          width: "80%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": () => {
            if (!this.disclaimers_validation) {
              this.$toast.error("Aceite os termos para continuar");
              setTimeout(() => {
                this.openDisclaimers();
              }, 100);
              return false;
            }
          }
        }
      );
    }
  },
  validations: {
    user: {
      email: { required, email },
      name: { required },
      password: { required },
      cpf: { minLength: minLength(14) },
    },
    login: {
      email: { required, email },
      password: { required },
    },
    confirm_password: { required },
  },
};
</script>
<style>
.extra-description {
  width: 40%;
  margin-left: auto;
  margin-right: auto;
}
@media (max-width: 800px) {
  .extra-description {
    width: 100%;
  }
}
</style>